export type ArchiveAfterFeedback = () => void | Promise<void>

export function getArchiveAfterFeedbackSuccess(
  archiveAfterSubmit: boolean,
  onArchive?: ArchiveAfterFeedback,
): ArchiveAfterFeedback | undefined {
  return archiveAfterSubmit ? onArchive : undefined
}
